/**
 * Helper functions to interact with the DOM
 */

/**
  * Checks if element el has ancestors with class className
  */
function isAncestorOf(el, className) {
  let element = el;
  while (element) {
    const parent = element.parentNode;
    if (parent && parent.className && parent.className.indexOf(className) > -1) {
      return true;
    }
    element = parent;
  }
  return false;
}

export default {
  isAncestorOf,
};
